function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo } from "react";
import styled, { css } from "styled-components";
import animation from "../../../helpers/animation";
import color, { dividerColor } from "../../../helpers/color";
import { secondaryBackground } from "../../../helpers/background";
import { useScope } from "./state/scope";
export const StyledCursor = /*#__PURE__*/memo(styled.div.attrs(({
  left,
  ...props
}) => ({
  ...props,
  style: {
    left
  }
})).withConfig({
  displayName: "StyledCursor",
  componentId: "sc-1uv60b7-0"
})(["", ";position:absolute;z-index:1;top:", "px;bottom:0;width:2px;background-color:currentColor;color:", ";font-size:11px;transform:", ";will-change:left;", ""], animation, ({
  top
}) => top !== undefined ? top : -26, color, ({
  align
}) => align !== "left" && "translateX(-1px)", ({
  onClick
}) => onClick && css(["cursor:pointer;"])));
StyledCursor.defaultProps = {
  color: "default"
};
export const Label = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "Label",
  componentId: "sc-1uv60b7-1"
})(["", " position:absolute;top:0;padding:0 8px;min-width:80px;border-left:2px solid ", ";border-right:2px solid ", ";color:currentColor;line-height:24px;text-transform:uppercase;white-space:nowrap;", ""], props => !props.transparent && secondaryBackground(props), dividerColor, dividerColor, ({
  align
}) => align === "left" ? css(["right:0px;border-right-color:currentColor;"]) : css(["left:0px;border-left-color:currentColor;"])));
Label.defaultProps = {
  align: "right"
};
const Cursor = /*#__PURE__*/memo(({
  align,
  position,
  transparent,
  children,
  ...props
}) => {
  const {
    start,
    length
  } = useScope();
  return /*#__PURE__*/React.createElement(StyledCursor, _extends({
    left: `${Math.max(0, (position - start) / length) * 100}%`
  }, props), children && /*#__PURE__*/React.createElement(Label, {
    align: align,
    transparent: transparent
  }, children));
});
export default Cursor;
//# sourceMappingURL=Cursor.js.map